import {useFormContext} from '@logistics-frontend/form/v2'
import {get} from '@logistics-frontend/utils'
import {useMemo} from 'react'

import {DeliveryType, DestinationPointDeliveryMethod} from 'src/shared/types'

function useNddDestinationPointCoordinates() {
  const {watch} = useFormContext()
  const destinationPointDeliveryMethod = watch('destinationPoints.0._deliveryMethod')

  const addressCoordinates = watch('destinationPoints.0.address.coordinates')
  const pickupPointCoordinates = watch('destinationPoints.0.pickUpPoint.point.position')

  const addressCoordinatesLongitude = get('[0]', addressCoordinates)
  const addressCoordinatesLatitude = get('[1]', addressCoordinates)

  const pickupPointCoordinatesLongitude = get('longitude', pickupPointCoordinates)
  const pickupPointCoordinatesLatitude = get('latitude', pickupPointCoordinates)

  return useMemo(() => {
    const result: number[][] = []

    switch (destinationPointDeliveryMethod) {
      case DestinationPointDeliveryMethod.Address:
        if (addressCoordinatesLongitude && addressCoordinatesLatitude) {
          result.push([addressCoordinatesLongitude, addressCoordinatesLatitude])
        }
        break
      case DestinationPointDeliveryMethod.PickUpPoint: {
        if (pickupPointCoordinatesLatitude && pickupPointCoordinatesLongitude) {
          result.push([pickupPointCoordinatesLongitude, pickupPointCoordinatesLatitude])
        }
        break
      }
    }

    return result
  }, [
    addressCoordinatesLatitude,
    addressCoordinatesLongitude,
    destinationPointDeliveryMethod,
    pickupPointCoordinatesLatitude,
    pickupPointCoordinatesLongitude,
  ])
}

function useSddExpressDestinationPointsCoordinates() {
  const {watch} = useFormContext()
  const points = watch('destinationPoints')

  // Points - это массив объектов, поэтому для сравнения используем JSON.stringify
  const hash = JSON.stringify(points)

  return useMemo(() => {
    if (points === undefined) {
      return []
    }

    // @ts-expect-error имплицинтый any
    return points.map(point => point?.address?.coordinates)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash, points])
}

export function useDestinationPointsCoordinates() {
  const {watch} = useFormContext()
  const sddExpressDestinationPointsCoordinates = useSddExpressDestinationPointsCoordinates()
  const nddDestinationPointCoordinates = useNddDestinationPointCoordinates()

  const deliveryType = watch('deliveryType')

  return useMemo(() => {
    switch (deliveryType) {
      case DeliveryType.Express:
      case DeliveryType.SDD:
        return sddExpressDestinationPointsCoordinates
      case DeliveryType.NDD:
        return nddDestinationPointCoordinates
      default:
        return []
    }
  }, [deliveryType, nddDestinationPointCoordinates, sddExpressDestinationPointsCoordinates])
}
